import { ACCOUNT_TYPES } from '@/accounts/constants/constants.js';

import { useSubscriptionStore } from '@/stores/subscription.store';

/**
 * @returns {Promise<Array>}
 */
export async function fetchAccountTypes () {
    const promises = Object.values(ACCOUNT_TYPES).map((type) => {
        return useSubscriptionStore().loadSetting({ setting: type.setting, retrieveMetadata: false })
            .catch((error) => error);
    });

    return Promise.all(promises);
}
